export const cities = [
    { id: 1, name: 'Cali' },
    { id: 2, name: 'Bogota D.C.' },
    { id: 3, name: 'Cúcuta' },
    { id: 4, name: 'Medellín' },
    { id: 5, name: 'Cartagena' },
    { id: 6, name: 'Santa Marta' },
    { id: 7, name: 'Bucaramanga' },
    { id: 8, name: 'Barranquilla' },
    { id: 9, name: 'Aguazul'},
    { id: 10, name: 'Cómbita'},
    { id: 11, name: 'Cota'},
    { id: 12, name: 'Duitama'},
    { id: 13, name: 'Funza'},
    { id: 14, name: 'Girardot'},
    { id: 15, name: 'Mosquera'},
    { id: 16, name: 'Neiva'},
    { id: 17, name: 'Rionegro'},
    { id: 18, name: 'Saravena'},
    { id: 19, name: 'Soacha'},
    { id: 20, name: 'Tenjo'},
    { id: 21, name: 'Tocancipá'},
    { id: 22, name: 'Tunja'},
    { id: 23, name: 'Ventaquemada'},
    { id: 24, name: 'Yumbo'}
    
]
export const zones = [
    { id: 1, name: 'Antioquia' },
    { id: 2, name: 'Boyaca' },
    { id: 3, name: 'Centro' },
    { id: 4, name: 'Costa' },
    { id: 5, name: 'Funza, Mosquera y Madrid' },
    { id: 6, name: 'OCC 1' },
    { id: 7, name: 'OCC 2' },
    { id: 8, name: 'Norte 1' },
    { id: 9, name: 'Norte 2' },
    { id: 10, name: 'Santander' },
    { id: 11, name: 'Sur' },
    { id: 12, name: 'Valle' },
    { id: 13, name: 'Zona FB Autonorte' },
    { id: 14, name: 'Zona FB Calle 80' }
]
export const channels = [
    {
        channel: 'Distribuidores',
        subchannels: [
            { id: 1, name: 'Distribuidores Esp (14%)' },
            { id: 2, name: 'Monodistribuidores (8%)' }
        ]
    },
    {
        channel: 'Food Service',
        subchannels: [
            { id: 3, name: 'Cadenas (8%)' },
            { id: 11, name: 'Neg Esp (17%)' },
            { id: 12, name: 'Cadenas Key (15%)' },
            { id: 5, name: 'Fs Tradicional (3%)' },
            { id: 7, name: 'Institucional (15%)' ,},
            { id: 14, name: 'Cadenas Emergente (5%)' }
        ]
    },
    {
        channel: 'Industrial',
        subchannels: [
            { id: 6, name: 'Gpyme Especializado (8%)' },
            { id: 13, name: 'Gpyme Entrega Sostenible (0%)' },
            { id: 10, name: 'Gpyme Granel (15%)' },
            { id: 4, name: 'Gpyme LC (12%)' },
            { id: 15, name: 'Gpyme Emergente (5%)' }
        ]
    },
    //{ id: 8, name: 'No disponible' },
    { id: 9, name: 'GGI Especializado' }
]
export const pqrs_subject = [
    { id: 1, name: 'Tiempos de entrega', area: 'logistica' },
    { id: 2, name: 'Producto sucio', area: 'logistica' },
    { id: 3, name: 'Transportador', area: 'logistica' },
    { id: 4, name: 'Documentos', area: 'logistica' },
    { id: 5, name: 'Solidificación', area: 'calidad' },
    { id: 6, name: 'Faltante en Kgs', area: 'logistica' },
    { id: 7, name: 'Bajo rendimiento', area: 'calidad' },
    { id: 8, name: 'Certificado de calidad', area: 'calidad' },
    { id: 9, name: 'Precio erróneo', area: 'comercial' },
    { id: 10, name: 'Precio erróneo', area: 'facturación' },
    { id: 11, name: 'Precio erróneo', area: 'parámetros del sistema' },
    { id: 12, name: 'Cliente no recibe pedido', area: 'comercial' },
    { id: 13, name: 'Otros' }
]
export const pqrs_impact = [
    { id: 1, name: 'Bajo' },
    { id: 2, name: 'Medio' },
    { id: 3, name: 'Alto' }
]
export const pqrs_states = [
    { id: 1, name: 'En trámite' },
    { id: 2, name: 'Cerrado' }
]
export const postventa_subject = [
    { id: 1, name: 'Prearranque' },
    { id: 2, name: 'Arranque' },
    { id: 3, name: 'Seguimiento arranque' },
    { id: 4, name: 'Postventa' },
    { id: 5, name: 'Aceite no está durando igual' },
    { id: 6, name: 'Aceite se quema muy rápido' },
    { id: 7, name: 'El aceite espuma' },
    { id: 8, name: 'Novedad en producto terminado' },
    { id: 9, name: 'Aceite solidificado' },
    { id: 10, name: 'Aceite con olor diferente al característico' }
]
export const orderStatus = [
    { id: 0, name: 'Borrador' },
    { id: 1, name: 'Cargado' },
    { id: 2, name: 'Bloqueo Cupo' },
    { id: 3, name: 'Bloqueo Días Mora' },
    { id: 4, name: 'Ok Cartera' },
    { id: 5, name: 'En Producción' },
    { id: 6, name: 'Producido' },
    { id: 7, name: 'Enrutado' },
    { id: 8, name: 'Entregado' },
    { id: 9, name: 'Anulado' }
]
export const business = [
    { id: 1, name: 'Dogal' },
    { id: 2, name: 'Inwoil' }
]
export const discount = [
    { id: 1, name: 'Entrega Centralizada' },
    { id: 2, name: 'Pronto Pago' }
]
export const payment = [
    { id: 1, name: 'Contado' },
    { id: 2, name: 'Crédito' },
    { id: 3, name: 'Anticipado' }
]
export const delivery = [
    { id: 1, name: 'Centralizada' },
    { id: 2, name: 'Punto a punto' }
]